import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BREADCRUMBS } from 'config';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { UserWizardService } from 'lib/ng2-sapmp/src/providers';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { STEPINDICATORS } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';

@Component({
  selector: 'app-manage-users',
  providers: [StepIndicatorService],
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss']
})
export class ManageUsersComponent implements OnInit {

  breadCrumbs: BreadCrumbModel[];
  steps: StepIndicatorModel[];
  stepSessionName: string;
  singleBreadCrumb: BreadCrumbModel;
  title: string;
  pivots: Array<MobilePivotModel>;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute, private stepIndicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService, private userWizardService: UserWizardService) {
    this.stepSessionName = 'manageUsers';
    this.singleBreadCrumb = new BreadCrumbModel();
    this.pivots = new Array<MobilePivotModel>();
  }

  ngOnInit() {
    this.userWizardService.getMessage().subscribe(
      (res: string) => {
        this.title = res;
      }
    );

    this.userWizardService.getPivot().subscribe(
      (res: Array<MobilePivotModel>) => {
        this.pivots = res;
      }
    );
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Assign or un-assign licenses', routerLink: '/manageUsers/action' });
    document.title = 'AT&T Business Console - Checkout - Terms and Conditions';
    this.steps = STEPINDICATORS.manageUsers.slice();
    if (this.stepIndicatorService.getSteps(this.stepSessionName) === null) {
      this.stepIndicatorService.setSteps(this.steps, this.stepSessionName);
    }
    this.steps = this.stepIndicatorService.getSteps(this.stepSessionName);
  }
}
